import packageJson from '../../../../package.json';

export const BOARD_FILTERS_TOUR_KEY = 'board-filters';

export const BOARD_FILTERS_TOUR_TARGETS = {
  TRIGGER: '[data-tour="bsf-trigger"]',
  SCOPE_GROUP: '[data-tour="bsf-scope-group"]',
  SCOPE_EM_ABERTO: '[data-tour="bsf-scope-em-aberto"]',
  SCOPE_TECNICOS: '[data-tour="bsf-scope-tecnicos"]',
  SCOPE_AMBOS: '[data-tour="bsf-scope-ambos"]',
  CHIPS: '[data-tour="bsf-chips"]',
};

/** Tour ativo só se enabled no package, tourKey=board-filters e tourVirtual.version === package.version */
export function getBoardFiltersTourSettings() {
  const tourConfig = packageJson.tourVirtual || {};
  const tourKey = String(tourConfig.tourKey ?? BOARD_FILTERS_TOUR_KEY).trim();
  const enabled = tourConfig.enabled === true && tourKey === BOARD_FILTERS_TOUR_KEY;
  const configVersion = String(tourConfig.version ?? '').trim();
  const appVersion = String(packageJson.version ?? '').trim();
  const versionMatch = Boolean(configVersion && configVersion === appVersion);

  return {
    active: enabled && versionMatch,
    tourVersion: versionMatch ? configVersion : null,
    tourKey: BOARD_FILTERS_TOUR_KEY,
  };
}
